import { useEffect, useState } from "react";
import getPruebas from "../services/Pruebas/getPruebas";
import { useSelector, useDispatch } from "react-redux";
import {
  addPruebas,
  addEstado,
} from "../../redux/reducers/Pruebas/PruebasSlice";

export default function useGetClases() {
  const [loading, setLoading] = useState(true);
  const estado = useSelector((state) => state.prueba.estado);
  const datosTabla = useSelector((state) => state.prueba.value);
  const dispatch = useDispatch();

  useEffect(() => {
    if (datosTabla.length === 0 && estado === false) {
      getPruebas(addEstado, dispatch).then((result) => {
        setLoading(false);
        const moment = require("moment");
        const datosTabla = [];
        let fecha;
        let data2 = [];
        data2 = result.items;
        data2.forEach((x) => {
          const date = new Date(x.st);
          const horas = moment(x.st).format("hh:mm");
          let hora;

          if (date.toLocaleString().toUpperCase().indexOf("A") !== -1) {
            hora = date
              .toLocaleString()
              .slice(
                date.toLocaleString().toUpperCase().indexOf("A") - 1,
                date.toLocaleString().toUpperCase().indexOf("M") + 1
              );
          } else {
            hora = date
              .toLocaleString()
              .slice(
                date.toLocaleString().toUpperCase().indexOf("P") - 1,
                date.toLocaleString().toUpperCase().indexOf("M") + 1
              );
          }

          fecha =
            moment(x.st).format("YYYY-MM-DD") +
            " " +
            horas +
            "" +
            hora.toUpperCase();
          datosTabla.push({
            clase: x.clase,
            clase_id: x.clase_id,
            id: x.id,
            instance: x.instance,
            ip: x.ip,
            name: x.name,
            st: fecha,
            user: x.user,
            user_id: x.user_id,
          });
        });
        dispatch(addPruebas(datosTabla));
      });
    } else {
      setLoading(false);
    }
  }, [datosTabla]);
  return { loading };
}
